import $ from 'jquery';

$(function () {

    if ($('#brand_home_page').length) {
        setTimeout(() => {
            $('#brand_home_page .filter').css('width', '100%');
        }, 250);
    }

});